import api from './api';

export async function getEventOption() {

}

export default async function postAchievement(name) {
 return api(`leaderboard/${name}/`, null, 'PUT');
}